// This File is to allow for support with the new TL syntax, please keep this up to date as keys.txt changes,
// or if we want to update the text on a string
// we have a tool that will build a legacyi18nObject using this mapping
// the tool is buildLegacyI18n in @bingads-webui-campaign/smart-i18n
// this file is exported separately, because we don't want the _TL_ syntax in the main exported code,
// as it breaks if not running through the bundler
export const legacyStrings = {
  Prepay_FundingPage_CheckInstructionsHeader: _TL_(
    'Check instructions',
    {
      comment: 'Text to show for the section header for check payment instructions',
    }
  ),
  Prepay_FundingPage_CheckPayeeLabel: _TL_(
    'Make payments to',
    {
      comment: 'Label text for the check payee in the offline payment instructions',
    }
  ),
  Prepay_FundingPage_CheckMailingAddressLabel: _TL_(
    'Send check to',
    {
      comment: 'Label to show for the address where checks can be mailed to in the prepay funding page.',
    }
  ),
  Prepay_FundingPage_CheckExpressMailingAddressLabel: _TL_(
    'Express mail',
    {
      comment: 'Label text for the express mailing option for checks.',
    }
  ),
  Prepay_FundingPage_WhatToExpectLabel: _TL_('What to expect'),
  Prepay_FundingPage_WhatToExpectCheck: _TL_('It can take between 7 and 14 days after you mail your check for the funds to appear in your Microsoft Advertising account.'),
  Prepay_FundingPage_WireInstructionsHeader: _TL_(
    'Wire transfer instructions',
    {
      comment: 'Text to show for the section header for wire payment instructions',
    }
  ),
  OfflinePaymentInstructionLabel_bankName: _TL_('Bank name'),
  Prepay_FundingPage_WhatToExpectWire: _TL_('It can take up to 5 days after the wire transfer is complete for the funds to appear in your Microsoft Advertising account.'),
};

export type LegacyStrings = typeof legacyStrings;
